<template>
  <div class="bigbox" :class="{'navSm':!isOpenMenu}">
    <p class="collpanBtn" @click="changeMunuBig" :style="{height:collpanHeight}"><i class="ar_img" :class="[isOpenMenu?'el-icon-s-fold':'el-icon-s-unfold']"></i></p>
    <div class="bigbox2" :style="{'padding-top':collpanHeight}">
      <div class="menuBox">
        <el-tooltip :disabled="isOpenMenu" class="item" effect="dark" :content="$t('m.streamer_manage')" placement="right">
          <router-link to="/approval/anchor-approval">
            <img class="menuImg" src="../assets/img/guanli_icon_02.png" alt="">
            <p>{{$t('m.streamer_manage')}}</p>
          </router-link>
        </el-tooltip>
        <el-tooltip :disabled="isOpenMenu" class="item" effect="dark" :content="$t('m.sereamer_apply')" placement="right">
          <router-link to="/anchor/management">
              <img class="menuImg" src="../assets/img/guanli_icon_03.png" alt="">
            <p>{{$t('m.sereamer_apply')}}</p>
          </router-link>
        </el-tooltip>
        <el-tooltip :disabled="isOpenMenu" class="item" effect="dark" content="主播收益" placement="right">
          <router-link to="/revenues/anchor-revenues">
            <img class="menuImg" src="../assets/img/guanli_icon_04.png" alt="">
            <p>{{$t('m.anchor_earings')}}</p>
          </router-link>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props:{
      isOpenMenu: {
        type: Boolean,
        default () {
          return true;
        }
      },
      isBigPage: {
        type: Boolean,
        default () {
          return true;
        }
      },
      collpanHeight: {
        type: String,
        default () {
          return '';
        }
      },
    },
    data() {
      return {
        //isOpenMenu:true,//是否展开菜单
      };
    },
    mounted() {},
    methods: {

        changeMunuBig(){
          this.$emit('changeMunuBig');
        }
    },
  };

</script>
<style lang="less" scoped>
.bigbox{
  height: 100%;
  position: relative;
}
.collpanBtn{
  position: absolute;
  width: 100%;
  padding: 5px;
  box-sizing: border-box;
  font-size: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 1;
  cursor: pointer;
}
.bigbox2{
  height: 100%;
  box-sizing: border-box;
}
.menuBox{
  height: 100%;
  overflow-y: auto;
}

.menuBox::-webkit-scrollbar {
  display: none;

}
  .menuBox p{
    padding: 5px 0;
  }
  .menuBox a{
    height: 155px;
    color: #fff;
    text-decoration: none;
    font-size: 14px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .menuImg{
    width: 48px;
    height: 48px;
  }

  .menuBox a:hover,.linkActive{
    background-color: rgba(0,0,0,.13);
  }

/* .navSm .collpanBtn{
  font-size: 18px;
}
.navSm .menuBox a{
  height: 60px;
}
.navSm .menuBox a .menuImg{
  width: 28px;
  height: 28px;
} */
.navSm .menuBox a p{
  display: none;
}

  @media only screen and (max-width: 767px){
    .menuBox a{
      height: 120px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/pageNav.vue